import React from "react"
import PropTypes from "prop-types"
import Content from "../../components/Content"

export const containerBausteinPrototype = [
    {
        key: "connections",
        type: "SELECTTREE",
        label: "Path",
        size: 6,
        options: "bausteine",
    },
]

const ContainerBausteinRef = ({container, payload}) => {
    const baustein = container?.connections?.origin
    if (!baustein) return null
    return (
        <>
            {(baustein.children || []).map((child) => (
                <Content
                    key={child.id}
                    child={child}
                    payload={payload}
                />
            ))}
        </>
    )
}

export default ContainerBausteinRef
